import { StaticPageConfig } from "@7egend/dxp-web-core/lib/modules/cms/StaticPages/types"
import { CUSTOM_BLOCKS } from "../blocks"

const { container, image, text, title } = CUSTOM_BLOCKS.types

export default {
	sections: {
		"7": {
			containers: {
				"individual-activities/header": {
					blocks: [
						{
							types: [`${image.type}_${image.style}`],
						},
						{
							types: [`${title.type}_${title.style}`],
						},
					],
				},
				"individual-activities/how_it_works": {
					blocks: [
						{
							types: [container.type],
							container: {
								blocks: [
									{
										types: [`${image.type}_${image.style}`],
									},
									{
										types: [`${title.type}_${title.style}`],
									},
									{
										types: [`${text.type}_${text.style}`],
									},
								],
							},
						},
						{
							types: [container.type],
							container: {
								blocks: [
									{
										types: [`${image.type}_${image.style}`],
									},
									{
										types: [`${title.type}_${title.style}`],
									},
									{
										types: [`${text.type}_${text.style}`],
									},
								],
							},
						},
						{
							types: [container.type],
							container: {
								blocks: [
									{
										types: [`${image.type}_${image.style}`],
									},
									{
										types: [`${title.type}_${title.style}`],
									},
									{
										types: [`${text.type}_${text.style}`],
									},
								],
							},
						},
					],
				},
			},
		},
	},
} as StaticPageConfig
